// ABOUTME: Better Auth client for frontend session management.
// ABOUTME: Provides React hooks and methods for sign-in, sign-up, and sign-out.

import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient();
